const CST_TIMEZONE = "America/Chicago";

const cstDateTimeFormatter = new Intl.DateTimeFormat("en-US", {
	timeZone: CST_TIMEZONE,
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
	hour: "2-digit",
	minute: "2-digit",
	hourCycle: "h23",
	timeZoneName: "shortOffset",
});

const cstDateFormatter = new Intl.DateTimeFormat("en-US", {
	timeZone: CST_TIMEZONE,
	weekday: "long",
	month: "long",
	day: "numeric",
});

const cstTimeFormatter = new Intl.DateTimeFormat("en-US", {
	timeZone: CST_TIMEZONE,
	hour: "numeric",
	minute: "2-digit",
});

function getOffsetMinutes(date) {
	const timeZoneName = cstDateTimeFormatter
		.formatToParts(date)
		.find((part) => part.type === "timeZoneName")?.value;
	const match = timeZoneName?.match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);

	if (!match) return -360;

	const sign = match[1] === "-" ? -1 : 1;
	const hours = Number(match[2]);
	const minutes = Number(match[3] || 0);
	return sign * (hours * 60 + minutes);
}

export function cstDateAndTimeToIso(dateValue, timeValue) {
	if (!dateValue || !timeValue) return null;

	const [year, month, day] = dateValue.split("-").map(Number);
	const [hour, minute] = timeValue.split(":").map(Number);
	const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute));
	const cstOffsetMinutes = getOffsetMinutes(utcGuess);

	return new Date(utcGuess.getTime() - cstOffsetMinutes * 60_000).toISOString();
}

export function isoToCstDateAndTime(isoValue) {
	if (!isoValue) return { date: "", time: "" };

	const parts = cstDateTimeFormatter.formatToParts(new Date(isoValue));
	const getPart = (type) => parts.find((part) => part.type === type)?.value || "";

	return {
		date: `${getPart("year")}-${getPart("month")}-${getPart("day")}`,
		time: `${getPart("hour")}:${getPart("minute")}`,
	};
}

export function formatHoursLine(opensAt, closesAt) {
	if (!opensAt || !closesAt) return "";

	const opensDate = new Date(opensAt);
	const closesDate = new Date(closesAt);
	return `${cstDateFormatter.format(opensDate)}: ${cstTimeFormatter.format(opensDate)} - ${cstTimeFormatter.format(closesDate)}`;
}

